export default {
  category: 'Shops & SKUs',
};
